<template>
    <div
            class="cursor-pointer inline-flex items-center flex-nowrap p-2 tall:p-3 text-sm"
            :class="{
                'bg-slate-blue-900': active,
                'ring-2 ring-green': active
            }"
            @click="$emit('click', code)"
    >
        <flag
            :country-code="countryCode"
            class="shrink-0 ltr:mr-3 rtl:ml-3"
            :class="flagClasses"
        />{{ name }}
    </div>
</template>

<script>
import Flag from '/src/components/Flag.vue'

const langToCountryMap = {
  en: 'gb',
  zh: 'cn',
  ar: 'sa'
}

export default {
  name: 'LangItem',
  components: { Flag },
  emits: ['click'],
  props: {
    code: {
      type: String,
      required: true
    },
    name: {
      type: String
    },
    flagClasses: {
      type: Array,
      default () {
          return ['w-8']
      }
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    countryCode: function () {
      return langToCountryMap[this.code] ?? this.code
    }
  }
}
</script>
